"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;const NoProvider=()=>null;var _default=exports.default=NoProvider;